import React, { FC, ReactElement, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { localizeType } from '../../../commonType';
import withLocalization from '../../hoc/withLocalization';
import ParseHtml from '../ParseHtml/ParseHtml';
import './DopInformation.scss';

interface DoPDetailsType {
  dopCodeDetails?: string;
  localize?: localizeType;
}
const DopInformation: FC<DoPDetailsType> = (props: DoPDetailsType): ReactElement => {
  const [show, setShow] = useState(false);

  const { localize, dopCodeDetails } = props;

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <button className="textDeco marginTop button-dop" onClick={handleShow}>
        {localize ? localize('preview-sales-engine.static-content.copy.select-destination-page.dop-link') : ''}
      </button>
      <Modal
        dialogClassName="modal-custom-dop"
        show={show}
        backdrop="static"
        keyboard="false"
        scrollable={true}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <ParseHtml htmlInput={dopCodeDetails} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {localize ? localize('preview-sales-engine.static-content.copy.DOP.ok-button') : ''}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withLocalization(DopInformation);
